export default __webpack_public_path__ + "pro-tools.7b73c398.png";